import { RR_TABLE_FIELD_TYPE } from '../../enum/table/table-field-type.enum';
import { RRISettings } from '../../interfaces/base-settings.interface';
import { RRITableFieldSettings } from '../../interfaces/table/table-field-settings.interface';

export class RRTableFieldSettingsModel<T>
  implements RRISettings<RR_TABLE_FIELD_TYPE, RRITableFieldSettings<T>>
{
  type: RR_TABLE_FIELD_TYPE;
  settings: RRITableFieldSettings<T>;
}
